import { useTranslation } from 'react-i18next';
// '@mui
import { enUS, arEG } from '@mui/material/locale';

// ----------------------------------------------------------------------

const LANGS = [
  {
    label: 'عربي',
    value: 'ar',
    direction: 'rtl',
    systemValue: arEG,
    icon: '/static/icons/flags/flag_ar.svg',
  },
  {
    label: 'English',
    value: 'en',
    direction: 'ltr',
    systemValue: enUS,
    icon: '/static/icons/flags/flag_en.svg',
  },
];

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const langStorage = localStorage.getItem('i18nextLng');
  const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[1];

  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS,
  };
}
